var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticStyle: { "margin-bottom": "20px" } }, [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [_c("span", [_vm._v("關於我")])]
    ),
    _c("div", { staticClass: "user-profile" }, [
      _c(
        "div",
        { staticClass: "box-center" },
        [
          _c("pan-thumb", {
            attrs: {
              image:
                _vm.avatar !== "" &&
                _vm.avatar !== null &&
                _vm.avatar !== undefined
                  ? _vm.avatar
                  : _vm.emptyUserImg,
              height: "100px",
              width: "100px",
              hoverable: true,
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "box-center" }, [
        _c("div", { staticClass: "user-name text-center" }, [
          _vm._v(_vm._s(_vm.user.name)),
        ]),
        _c(
          "div",
          { staticClass: "user-role text-center text-muted" },
          [
            _vm._l(_vm.user.role, function (item) {
              return [_c("p", { key: item }, [_vm._v(_vm._s(item))])]
            }),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }